var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLaptopChart = function SvgLaptopChart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 633.902,
    height: 503.272,
    viewBox: "0 0 633.902 503.272",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: #02225b;\n      }\n\n      .cls-7 {\n        fill: #007bff;\n      }\n\n      .cls-8 {\n        fill: #35fdce;\n      }\n\n      .cls-9 {\n        fill: #63b3f2;\n      }\n\n      .cls-10 {\n        fill: #b5b9cc;\n      }\n\n      .cls-11 {\n        fill: #a4b6c7;\n      }\n\n      .cls-12 {\n        fill: #e6ebf0;\n      }\n\n      .cls-13 {\n        fill: #fff;\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-15 {\n        fill: #f2f2f2;\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-17 {\n        opacity: 0.5;\n      }\n\n      .cls-18 {\n        fill: #2196f3;\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-9);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02225b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007bff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003e80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35fdce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b7f67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63b3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325a79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5b9cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b5d66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.989,
    y1: 0.998,
    x2: 0.01,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02225b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007bff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.077,
    y1: -0.033,
    x2: 1.105,
    y2: 0.776,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9916",
    "data-name": "Group 9916",
    transform: "translate(-1159 -76.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9913",
    "data-name": "Group 9913",
    transform: "translate(1589.076 76.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    className: "cls-1",
    d: "M135.272,470.735l-32.157,19.12V288.224l32.157-19.12Z",
    transform: "translate(-60.948 -167.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    className: "cls-2",
    d: "M135.272,495.265l-32.157,19.12V234.2l32.157-19.12Z",
    transform: "translate(-18.781 -215.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    className: "cls-3",
    d: "M135.272,455.354l-32.157,19.12V322.1l32.157-19.12Z",
    transform: "translate(-103.115 -127.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    className: "cls-4",
    d: "M135.272,454.152l-32.157,19.12V324.748l32.157-19.12Z",
    transform: "translate(23.386 -198.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    className: "cls-5",
    d: "M135.272,440.308l-32.157,19.12V355.239l32.157-19.12Z",
    transform: "translate(65.554 -206.65)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9912",
    "data-name": "Group 9912",
    transform: "translate(1592.076 77.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1999-2",
    "data-name": "Path 1999",
    className: "cls-6",
    d: "M135.272,470.735l-32.157,19.12V288.224l32.157-19.12Z",
    transform: "translate(-60.948 -167.283)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000-2",
    "data-name": "Path 2000",
    className: "cls-7",
    d: "M135.272,495.265l-32.157,19.12V234.2l32.157-19.12Z",
    transform: "translate(-18.781 -215.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001-2",
    "data-name": "Path 2001",
    className: "cls-8",
    d: "M135.272,455.354l-32.157,19.12V322.1l32.157-19.12Z",
    transform: "translate(-103.115 -127.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002-2",
    "data-name": "Path 2002",
    className: "cls-9",
    d: "M135.272,454.152l-32.157,19.12V324.748l32.157-19.12Z",
    transform: "translate(23.386 -198.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003-2",
    "data-name": "Path 2003",
    className: "cls-10",
    d: "M135.272,440.308l-32.157,19.12V355.239l32.157-19.12Z",
    transform: "translate(65.554 -206.65)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9911",
    "data-name": "Group 9911",
    transform: "translate(1159 172.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9868",
    "data-name": "Group 9868",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    className: "cls-11",
    d: "M635.9,382.752a14.677,14.677,0,0,0-7.339-12.71L416.576,247.654a6.26,6.26,0,0,0-7.363.783c-.441.4-1.977,1.963-2.334,2.329a6.181,6.181,0,0,0-1.759,4.358v169.61L633.875,556.806h0a6.9,6.9,0,0,0,2.023-4.883Z",
    transform: "translate(-254.842 -246.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    className: "cls-11",
    d: "M685.641,495.831,456.885,363.759l-147.1,84.926a6.182,6.182,0,0,0-3.12,5.057c-.117,2.133-.04,8.956-.009,11a6.187,6.187,0,0,0,3.129,5.315L518.628,590.635a20.967,20.967,0,0,0,20.966,0L680.4,509.34a10.482,10.482,0,0,0,5.242-9.078Z",
    transform: "translate(-306.607 -185.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    className: "cls-12",
    d: "M456.872,363.759l-147.1,84.926a6.289,6.289,0,0,0,0,10.893L518.616,580.15a20.959,20.959,0,0,0,20.966,0l146.046-84.32Z",
    transform: "translate(-306.594 -185.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    className: "cls-13",
    d: "M630.148,494.232a4.194,4.194,0,0,0,.006-7.267l-195.2-112.7a4.2,4.2,0,0,0-4.186,0l-77.393,44.483a2.1,2.1,0,0,0,0,3.634L550.81,536.12a6.291,6.291,0,0,0,6.268.008Z",
    transform: "translate(-282.584 -180.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    className: "cls-14",
    d: "M353.371,420.055l77.393-44.483a4.194,4.194,0,0,1,4.186,0l195.2,112.7a4.105,4.105,0,0,1,2.015,2.976,4.143,4.143,0,0,0-2.015-4.286l-195.2-112.7a4.2,4.2,0,0,0-4.186,0l-77.393,44.483a2.08,2.08,0,0,0-.934,2.473A2.053,2.053,0,0,1,353.371,420.055Z",
    transform: "translate(-282.58 -180.12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    className: "cls-13",
    d: "M462.3,465.656l-54.2-31.293a2.1,2.1,0,0,0-2.093,0l-37.964,21.822a2.1,2.1,0,0,0,0,3.634L421.188,490.5a4.2,4.2,0,0,0,4.186,0l36.918-21.219A2.1,2.1,0,0,0,462.3,465.656Z",
    transform: "translate(-274.881 -148.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    className: "cls-14",
    d: "M368.033,457.458,406,435.638a2.1,2.1,0,0,1,2.093,0l54.2,31.293a2.049,2.049,0,0,1,.937,1.178,2.08,2.08,0,0,0-.937-2.454l-54.2-31.293a2.1,2.1,0,0,0-2.093,0l-37.964,21.822a2.079,2.079,0,0,0-.941,2.456A2.048,2.048,0,0,1,368.033,457.458Z",
    transform: "translate(-274.877 -148.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    className: "cls-15",
    d: "M633.875,556.11V384.079a14.679,14.679,0,0,0-7.337-12.71L414.555,248.98a6.29,6.29,0,0,0-9.435,5.447v169.61Z",
    transform: "translate(-254.842 -246.106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    className: "cls-16",
    d: "M411.992,413.314v-156.3l207.79,119.968v156.3Z",
    transform: "translate(-251.231 -241.435)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9865",
    "data-name": "Group 9865",
    className: "cls-17",
    transform: "translate(180.534 117.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    className: "cls-18",
    d: "M515.3,326.507l-.354-.2c-7.275-3.876-11.542,5.409-16.048,15.255-3.925,8.55-7.984,17.38-13.163,14.576-.038-.018-.075-.04-.114-.063-2.471-1.426-5.952-8.26-8.993-14.228-3.838-7.537-7.475-14.677-11.465-16.981a6.479,6.479,0,0,0-.912-.438c-6.361-2.433-10.05,5.812-13.619,13.786-2.572,5.748-5.234,11.717-8.473,12.445-1.634.375-6.681-2.11-11.392-4.83-2.027-1.17-3.991-2.383-5.592-3.431l-.218,3.644c.924.6,3.239,2.09,5.989,3.678,4.673,2.7,10.6,5.684,13.093,5.115,4.023-.921,6.744-7.008,9.629-13.459,3.078-6.866,6.573-14.663,11.119-12.921a2.567,2.567,0,0,1,.354.171c2.5,1.443,5.917,8.187,8.974,14.181,3.846,7.549,7.507,14.73,11.517,17.046.066.037.131.073.2.108,7.3,3.963,11.571-5.357,16.091-15.212,3.911-8.541,7.97-17.354,13.149-14.6.067.035.134.073.2.111,6.66,3.847,9.757,21.379,12.78,38.321,3.432,19.251,6.662,37.433,15.627,44.1a8.244,8.244,0,0,0,.793.525c5.014,2.9,7.011-4.441,9.156-12.152,1.626-5.853,3.656-13.1,6.564-11.848a2.419,2.419,0,0,1,.268.134c3.15,1.82,5.386,11.471,7.389,20.01,1.956,8.363,3.811,16.26,7.033,20.972,2.311,3.39,7.96,7.109,12.445,9.7,2.685,1.55,4.973,2.7,5.873,3.152l-.226-3.9c-1.622-.8-3.518-1.815-5.437-2.923-4.561-2.633-9.246-5.794-10.654-7.862-2.4-3.524-4.181-11.107-5.9-18.469-2.448-10.462-5.032-21.3-10.466-24.435a7.16,7.16,0,0,0-.723-.365c-5.092-2.192-7.138,5.2-9.318,13.011-1.567,5.63-3.556,12.6-6.09,11.142a1.869,1.869,0,0,1-.221-.15c-6.755-5.019-10.027-23.413-12.922-39.653-3.446-19.395-6.7-37.729-15.94-43.062",
    transform: "translate(-424.954 -323.99)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9866",
    "data-name": "Group 9866",
    transform: "translate(165.652 132.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    className: "cls-19",
    d: "M505.54,336.265l-.354-.2c-7.273-3.878-11.542,5.409-16.046,15.255-3.927,8.55-7.984,17.378-13.163,14.576-.038-.02-.076-.041-.114-.063-2.473-1.428-5.954-8.26-8.993-14.228-3.84-7.537-7.475-14.678-11.467-16.983a6.527,6.527,0,0,0-.911-.438c-6.363-2.433-10.05,5.812-13.619,13.787-2.574,5.748-5.236,11.716-8.474,12.445-1.632.375-6.682-2.111-11.392-4.83-2.026-1.17-3.991-2.384-5.592-3.432l-.217,3.644c.923.6,3.239,2.09,5.989,3.678,4.671,2.7,10.6,5.684,13.093,5.115,4.021-.921,6.743-7.008,9.627-13.459,3.078-6.865,6.573-14.661,11.121-12.919a2.539,2.539,0,0,1,.352.169c2.5,1.443,5.919,8.187,8.976,14.181,3.846,7.551,7.507,14.73,11.516,17.045q.1.057.2.11c7.3,3.962,11.571-5.359,16.092-15.212,3.91-8.541,7.969-17.354,13.148-14.6.069.037.136.073.2.113,6.662,3.846,9.757,21.379,12.78,38.321,3.434,19.25,6.662,37.432,15.628,44.1a8.062,8.062,0,0,0,.792.525c5.014,2.9,7.011-4.441,9.156-12.152,1.628-5.852,3.658-13.1,6.566-11.848a2.612,2.612,0,0,1,.268.136c3.149,1.818,5.386,11.471,7.388,20.008,1.956,8.364,3.811,16.26,7.034,20.974,2.31,3.388,7.958,7.109,12.445,9.7,2.685,1.551,4.971,2.7,5.871,3.153l-.226-3.9c-1.622-.8-3.518-1.814-5.437-2.921-4.56-2.633-9.246-5.794-10.654-7.862-2.4-3.524-4.18-11.107-5.9-18.469-2.448-10.462-5.031-21.3-10.465-24.435a7.149,7.149,0,0,0-.725-.365c-5.092-2.192-7.138,5.2-9.318,13.011-1.567,5.629-3.556,12.6-6.09,11.141a2,2,0,0,1-.221-.148c-6.753-5.02-10.027-23.414-12.921-39.654-3.448-19.395-6.706-37.729-15.941-43.061",
    transform: "translate(-415.198 -333.746)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9867",
    "data-name": "Group 9867",
    transform: "translate(180.535 47.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    className: "cls-13",
    d: "M480.93,310.372,425,278.079l-.01,3.434,55.933,32.293.01-3.434",
    transform: "translate(-424.937 -278.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    className: "cls-13",
    d: "M480.913,316.221,424.98,283.928l-.01,3.434L480.9,319.655l.01-3.434",
    transform: "translate(-424.945 -275.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    className: "cls-13",
    d: "M461.863,311.073l-36.9-21.3-.01,3.446,36.9,21.3.01-3.446",
    transform: "translate(-424.954 -271.936)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLaptopChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/laptop_chart.c0d7ff3a.svg";
export { ForwardRef as ReactComponent };